import React, { useCallback, useEffect, useState } from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);


const CheckoutForm = ({ productsData, customer_reference_number }) => {
  // console.log("productsData", productsData.price);
  const products = [
    {
      title: "Notions Group",
      price: productsData.price,
      // price: 3,
      name: "Customer",
      quantity: productsData.quantity,
      brand: "chocodate", // ! this brand for payment gateway return url select
    },
  ];


  // console.log(products);

  const fetchClientSecret = useCallback(async () => {
    try {
      const body = {
        products,
        customer_reference_number,
        shopName: "chocodate",
      };

      const headers = {
        "Content-Type": "application/json",
      };

      // Create a Checkout Session
      const response = await axios.post("/create-checkout-session", body, {
        headers: headers,
      });

      return response.data.clientSecret;
    } catch (error) {
      console.error("Error fetching client secret:", error);
      throw error; // Optionally re-throw to handle higher up
    }
  }, [products]);

  const options = { fetchClientSecret };

  return (
    <div>
      <div id="checkout">
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    </div>
  );
};

export default CheckoutForm;
